import { FTLDialog } from "../components/FTLDialog";
import { useServiceProps, dialogService } from "ftl-dashboards-core";
import React from "react";
export const DialogContainer = ({ style, service = dialogService, }) => {
    const [props] = useServiceProps(service);
    return (React.createElement(FTLDialog, Object.assign({}, props, { style: style, onCancel: (e) => {
            (props === null || props === void 0 ? void 0 : props.onCancel) && props.onCancel(e);
            service.closeDialog();
        }, onClose: (e) => {
            (props === null || props === void 0 ? void 0 : props.onClose) && props.onClose(e);
            service.closeDialog();
        } })));
};
//# sourceMappingURL=DialogContainer.js.map